module.exports = ".hour-counter.green {\n  color: rgb(93, 255, 87);\n}\n\n.hour-counter.orange {\n  color: rgb(255, 153, 51);\n}\n\n.hour-counter.red {\n  color: rgb(255, 0, 0);\n}\n\n.hour-counter.darkRed {\n  color: rgb(155, 0, 0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/payments_refunds/refund-inline.component.css
// module id = ./src/app/admin/payments_refunds/refund-inline.component.css
// module chunks = main